const numberFormatter = new Intl.NumberFormat('de-CH', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export default (value) => numberFormatter.format(value);
